import { BROACAST_SOURCES_SELECT_TAB } from '../../Types';

export default tab => {
  return dispatch => {
    const action = {
      type: BROACAST_SOURCES_SELECT_TAB,
      payload: tab
    };

    dispatch(action);
  };
};
